import { LitElement, html } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { OverlayConfig, OverlayEvents, OverlayPosition } from '../type';
import { classMap } from 'lit/directives/class-map.js';

@customElement('gz-info-overlay')
export class GzInfoOverlayWebComponent extends LitElement implements OverlayConfig {
  @property({ type: String, attribute: true, reflect: true })
  position: OverlayPosition = OverlayPosition.TOP_RIGHT;

  @property({ type: String, attribute: true, reflect: true })
  backgroundColor = '#006dff';

  @property({ type: Number, attribute: true, reflect: true })
  public zIndex = 9999;

  content: HTMLElement;

  @property({ type: Boolean, attribute: true, reflect: true })
  isOpen = false;

  @query('#arrow')
  arrow: HTMLElement;

  private eventListeners: { event: string; listener: EventListenerOrEventListenerObject; target: EventTarget }[] = [];

  static get styles() {
    return styles;
  }

  render() {
    const classes = {
      ['arrow-position-' + this.position]: this.position,
    };

    return html` <div
      class="container d-flex flex-column"
      style="z-index:${this.zIndex}; background-color: ${this.backgroundColor}"
    >
      <span id="arrow" class="arrow ${classMap(classes)}" style="border-bottom-color: ${this.backgroundColor}"></span>
      <slot></slot>
    </div>`;
  }

  public close(shouldRemove: boolean = true): void {
    this.isOpen = false;

    this.removeElementEventListeners();
    if (shouldRemove) {
      this.remove();
    }
    this.dispatchEvent(new CustomEvent(OverlayEvents.OVERLAY_CLOSE, {}));
  }

  public open(): void {
    this.isOpen = true;
    this.dispatchEvent(new CustomEvent(OverlayEvents.OVERLAY_OPEN, {}));
  }

  public addOverlayEventListeners(target: Element | Window, events: string[], cb: Function): void {
    if (target) {
      events.forEach(event => {
        const listener = () => cb();
        target.addEventListener(event, listener);
        this.eventListeners.push({ event, listener, target });
      });
    }
  }

  private removeElementEventListeners(): void {
    this.eventListeners.forEach(({ event, listener, target }) => {
      target.removeEventListener(event, listener);
    });
    this.eventListeners = [];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-info-overlay': GzInfoOverlayWebComponent;
  }
}
